// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Xchp","requiredAsterisk":"Info_requiredAsterisk__ARyJ8"};